export default __webpack_public_path__ + "static/7-80bf558e71c88add4d68c70090e80ac7.png";